import React, { useState } from 'react';
import styled from 'styled-components';
import { ModalFooter } from 'styled_components/Common/ModalFooter';
import Modal from 'sub_components/Common/PortalModalNew';
import { PopUp } from 'styled_components/Common/PopUp';
import { Settings } from 'styled_components/Account/Settings';
import CardScroller from 'sub_components/Common/CardScroller';
import { ActionButton } from 'styled_components/Common/ActionButton';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { DailyTest } from 'styled_components/SVG/DailyTest';
import { DailySelector } from 'styled_components/SVG/DailySelector';
import { PieSelector } from 'styled_components/SVG/PieChart';
import { BarSelector } from 'styled_components/SVG/BarChart';
import { TICKET_TYPES } from 'utils/TicketConstants';
import { TrendSelector } from 'styled_components/SVG/TrendSelector';
import { Divider } from 'styled_components/Common/Divider';
import ShareCardContainer from 'blox_components/Storage/StorageOverviewDetail/Components/ShareCardContainer';
import AccordianItem from 'sub_components/Billing/AccordianItem';
import NewTicket from 'sub_components/Common/NewTicket';
import { Notifications } from 'styled_components/Account/Notifications';
import { AvatarApi } from 'services/avatar';
import DonutChart from 'sub_components/Common/DonutChart';
import { PortraitModalComponent } from 'styled_components/Common/PortraitModalComponent';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { SortProvider } from 'context/SortContext';
import { Filter } from 'styled_components/Common/Filter';
import { FilterProvider } from 'context/FilterContext';
import { ToggleButton } from 'styled_components/Common/ToggleButton';
import { IconButton } from 'styled_components/Common/IconButton';
import { LargeInfoDisplay } from 'styled_components/Common/LargeInfoDisplay';
import { CogSVG } from 'styled_components/SVG/CogSVG';
import { UserDetails } from 'styled_components/Account/UserDetails';
const profileImage = AvatarApi.getGenericAvatar();

const ComponentListStyle = styled.div`
	.components-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		.square {
			width: 96px;
			height: 96px;
			border: 1px solid red;
		}
		.carousel-item-padding-40-px {
			padding: 40px;
		}
		.react-multi-carousel-list {
			height: 100px;
			width: 600px;
			border: 1px solid green;
		}

		.component {
			position: relative;
			margin-bottom: 10px;
			padding: 10px;
			.component-title {
				height: 30px;
			}
			.component-body {
				display: flex;
				justify-content: space-between;
				min-height: 50px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;
export const INVOICE_SUMMARY_HEADERS = {
	invoice_number: 'Invoice',
	billcycle: 'Sent',
	amount: 'Total',
	dueDate: 'Due',
	amount_due: 'Balance',
};
export const getHeaders = ['Header', 'Header', 'Header', 'Header', 'Header'];

export const INVOICE_DETAIL_HEADERS = {
	effectiveDate: 'Date',
	description: 'Description',
	amount: 'Amount',
};
const settingSelections = [
	{
		label: 'Edit Details',
		value: 'details',
	},
	{
		label: 'Avatar',
		value: 'avatar',
	},
	{
		label: 'Password',
		value: 'password',
	},
];
const invoices = [
	{
		amount: 1742,
		amount_due: 0,
		billcycle: '2021-09-01 ',
		customerid: 4450151,
		dueDate: '2021-09-01 ',
		filename: null,
		invoice_number: 12871,
		invoiceid: 52568955,
		published: true,
		status: 'Paid',
		type: 'Paid',
		transaction: [
			{
				amount: 1742,
				customerId: 4450151,
				description: 'Direct Deposit',
				effectiveDate: '2021-09-11',
				invoiceId: 52568955,
				invoiceNumber: 12871,
				invoiceTotal: 1742,
				outstandingBalance: 0,
				reference: null,
				transactionId: 769697456,
				transactionType: 'Payment',
				uri: 'https://secure.fusebill.com/v1/invoices/52568955',
			},
		],
	},
];

const selections = [
	{
		label: 'Edit Details',
		value: 'details',
	},
	{ label: 'Password', value: 'password' },
];
const Notification_Filters = ['Filter 1', 'Filter 2'];
const responsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 5,
	},
	desktop: {
		breakpoint: { max: 3000, min: 1024 },
		items: 3,
	},
	tablet: {
		breakpoint: { max: 1024, min: 464 },
		items: 2,
	},
	mobile: {
		breakpoint: { max: 464, min: 0 },
		items: 1,
	},
};
const theme1 = {
	account: '#416ba9',
	support: '#8060a9',
	storage: '#008388',
	billing: '#a8ad00',
	Cool_Gray_Med_1: '#a2a9ad',
	Cool_Gray_Light_3: '#edefef',
};
const popUpContent = (
	<div className='soft-error'>
		<div className='top-message'>Error message of your choice.</div>
		<div className='bottom-message'>
			If the problem persists please call
			<br />
			877-590-1684.
		</div>
	</div>
);
const fakeUsers = [
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
	{ firstname: 'Jason', lastname: 'Bourne', id: 5, userProfile: { profileImage: '2' } },
];

// const theme2 = {
// 	account: 'red',
// 	support: 'blue',
// 	storage: 'green',
// 	billing: 'orange',
// };
function clicky(id) {
	const element = document.getElementById(id);
	element.classList.toggle('active');
	document.getElementById(`${id}trans2`).beginElement();
	if (document.getElementById(`${id}trans3`)) {
		document.getElementById(`${id}trans3`).beginElement();
	}
}

function transitionImageOver(id) {
	const isIE = /*@cc_on!@*/ false || !!document.documentMode;
	// Edge 20+
	const isEdge = !isIE && !!window.StyleMedia;
	const windows = isIE || isEdge;
	if (windows) {
		document.getElementById('issue-request-component-wrapper').classList.add('windows');
	} else {
		document.getElementById(`${id}trans1`).beginElement();
	}
}
function checkSliderPosition(id) {
	const element = document.getElementById(id);
	let position = 'left';
	if (!element.classList[0].includes('1')) {
		if (element.classList[0].includes('2')) {
			position = 'right';
		} else if (element.classList[0].includes('3')) {
			position = 'right';
		} else if (element.classList[0].includes('0')) {
			position = 'left';
		}

		return position;
	}
}
function checkSliderPosition4(element) {
	let position4 = 'left';
	if (!element.classList[0].includes('1') && !element.classList[0].includes('2')) {
		if (element.classList[0].includes('2')) {
			position4 = 'right';
		} else if (element.classList[0].includes('3')) {
			position4 = 'right';
		} else if (element.classList[0].includes('0')) {
			position4 = 'left';
		}

		return position4;
	}
}

export const ComponentList = () => {
	const [toggle, setToggle] = useState('two');
	const [position, setPosition] = useState('left');
	const [showModal, setShowModal] = useState(false);
	const [popUp, setPopUp] = useState(false);
	const [modalType, setModalType] = useState('small');
	return (
		<ComponentListStyle>
			<div className='components-wrapper'>
				<div className='component'>
					<div className='component-title heading70'>Action Button</div>

					<div className='component-body'>
						<ActionButton
							id='special-id-1'
							onClick={() => clicky('special-id-1')}
							onMouseOver={() => transitionImageOver('special-id-1')}
							module='support'
						>
							<CogSVG id='special-id-1' />
						</ActionButton>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Blox Button</div>
					<div className='component-body'>
						<BloxButton
							id='button-5'
							text='TENLETTERS'
							module='storage'
							enabled={true}
							className='buttons41'
						/>

						<BloxButton
							text='12 LTR/SPACE'
							module='billing'
							enabled={true}
							id='button-6'
							className='buttons41'
						/>
						<BloxButton
							text='1414 LTR/SPACE'
							module='account'
							enabled={true}
							id='button-7'
							className='buttons41'
						/>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Toggle Buttons</div>
					<div className='component-body'>
						<BloxButton
							text='Show Toggle 2'
							module='support'
							enabled={true}
							id='button-1216'
							className='buttons41'
							onClick={() => setToggle('two')}
						/>
						<BloxButton
							text='Show Toggle 3'
							module='support'
							enabled={true}
							id='button-1214'
							className='buttons41'
							onClick={() => setToggle('three')}
						/>
						<BloxButton
							text='Show Toggle 4'
							module='support'
							enabled={true}
							id='button-1213'
							className='buttons41'
							onClick={() => setToggle('four')}
						/>
					</div>
				</div>
				<div className='component'>
					{toggle === 'two' && (
						<ToggleButton module='storage' id='toggle-slider' theme={theme1} groupName='togglers-1'>
							<BarSelector id='bar-selector-1' module='storage' theme={theme1} className={'bar'} />
							<PieSelector id='pie-selector-1' module='storage' theme={theme1} className={'pie'} />
						</ToggleButton>
					)}
					{toggle === 'three' && (
						<ToggleButton
							module='storage'
							id='toggle-slider-2'
							theme={theme1}
							groupName='togglers-2'
							checkSlider={() => setPosition(checkSliderPosition('toggle-slider-2'))}
						>
							<BarSelector
								id='bar-selector-2'
								module='storage'
								theme={theme1}
								className={'bar-2'}
							/>
							<DailySelector
								id='daily-selector-1'
								module='storage'
								theme={theme1}
								position={position}
								className={'daily'}
							/>
							<PieSelector
								id='pie-selector-2'
								module='storage'
								theme={theme1}
								className={'pie-2'}
							/>
						</ToggleButton>
					)}
					{toggle === 'four' && (
						<ToggleButton
							module='storage'
							id='toggle-slider-3'
							theme={theme1}
							groupName='togglers-3'
							checkSlider={() => setPosition(checkSliderPosition4('toggle-slider-3'))}
						>
							<BarSelector
								id='bar-selector-3'
								module='storage'
								theme={theme1}
								className={'bar-3'}
							/>
							<DailySelector
								id='daily-selector-2'
								module='storage'
								theme={theme1}
								position={position}
								className={'daily-2'}
							/>
							<TrendSelector
								id='trend-selector-1'
								module='storage'
								theme={theme1}
								position={position}
								className={'trend'}
							/>
							<PieSelector id='pie-selector-3' module='storage' theme={theme1} className='pie-3' />
						</ToggleButton>
					)}
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Icon Buttons</div>
					<div className='component-body'>
						<IconButton
							svgId='daily-selector-3'
							enabled={true}
							id='icon-button'
							module='storage'
							breakpoint={930}
						>
							<DailyTest
								id='daily-selector-3'
								module='storage'
								theme={theme1}
								position={position}
								className={'daily'}
							/>
						</IconButton>
						<br />
						<IconButton
							enabled={true}
							id='icon-button-2'
							module='storage'
							breakpoint={1344}
							svgId='daily-selector-3'
						>
							<DailyTest
								id='daily-selector-3'
								module='storage'
								theme={theme1}
								position={position}
								className={'daily'}
							/>
						</IconButton>
						<br />
						<IconButton
							svgId='daily-selector-3'
							enabled={true}
							id='icon-button-3'
							module='storage'
							breakpoint={2240}
						>
							<DailyTest
								id='daily-selector-3'
								module='storage'
								theme={theme1}
								position={position}
								className={'daily'}
							/>
						</IconButton>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Portrait Modal</div>
					<div className='component-body'>
						<BloxButton
							text='Small'
							module='support'
							enabled={true}
							id='modal-small'
							className='buttons41'
							onClick={() => {
								setModalType('small');
								setShowModal(!showModal);
							}}
						/>
						<BloxButton
							text='Medium'
							module='support'
							enabled={true}
							id='modal-medium'
							className='buttons41'
							onClick={() => {
								setModalType('medium');
								setShowModal(!showModal);
							}}
						/>
						<BloxButton
							text='Large'
							module='support'
							enabled={true}
							id='modal-large'
							className='buttons41'
							onClick={() => {
								setModalType('large');
								setShowModal(!showModal);
							}}
						/>
						<PortraitModalComponent
							closeModal={() => setShowModal(!showModal)}
							show={showModal}
							//header={getHeader(activePageIndex)}
							title='MODAL TITLE'
							subTitle={'Modal subtitle'}
							size={modalType}
							breakpoint={930}
						>
							<ModalFooter
								cypressId='footer'
								id='footer'
								buttonText1={'Next'}
								buttonText2='Back'
								buttonActive1={true}
								buttonActive2={true}
								module='storage'
								buttonFunction1={() => {}}
								size={modalType}
								buttonFunction2={() => {}}
							/>
						</PortraitModalComponent>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Pop Up Modal</div>
					<div className='component-body '>
						<BloxButton
							text='Show'
							module='support'
							enabled={true}
							id='pop-up'
							className='buttons41'
							onClick={() => {
								setPopUp(!popUp);
							}}
						/>
						{popUp && (
							<Modal>
								<PopUp
									showModal={popUp}
									closeModal={() => setPopUp(!popUp)}
									customBody={popUpContent}
									footer={
										<BloxButton
											className='buttons41'
											id='okay'
											text='CLOSE'
											module='support'
											enabled={true}
											onClick={() => setPopUp(!popUp)}
											cypressId='okay'
										/>
									}
									title={'Title Text'}
									text='More text'
									module='support'
								/>
							</Modal>
						)}
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Ticket Donuts</div>
					<div className='component-body'>
						<DonutChart ticketType={TICKET_TYPES.BILLING} showTitle={() => {}} id='billing' />

						<DonutChart ticketType={TICKET_TYPES.SUPPORT} showTitle={() => {}} id='support' />
						<DonutChart ticketType={TICKET_TYPES.STORAGE} showTitle={() => {}} id='storage' />
						<DonutChart ticketType={TICKET_TYPES.ACCOUNT} showTitle={() => {}} id='account' />
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Information Display</div>
					<div className='component-body '>
						<LargeInfoDisplay
							type='default'
							data={{
								header: {
									image: null,
									title: 'Header Title',
									details1: 'Details...',
								},
								main: {
									title: 'Test Profile',
									fields: [
										{ label: 'Label', value: 'any data' },
										{ label: 'Label', value: 'value' },
										{ label: 'Label', value: 'value' },
										{ label: 'Label', value: 'value' },
									],
								},
								footer: {
									buttonID: 'user-profile',
									buttonText: 'EDIT INFO',
									onClick: () => {},
								},
							}}
							module='support'
							onClick={() => {}}
							cypressId='LI-my-profile-link'
						/>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Horizontal Carousel</div>
					<div className='component-body '>
						<Carousel responsive={responsive} itemClass='carousel-item-padding-40-px'>
							<div className='square'>Item 1</div>
							<div className='square'>Item 2</div>
							<div className='square'>Item 3</div>
							<div className='square'>Item 4</div>
						</Carousel>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Veritcal Carousel</div>
					<div className='component-body '>
						<CardScroller data={fakeUsers} onClick={() => {}} selectedId={5} showButton={true} />
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Filter DropDown</div>
					<div className='component-body '>
						<FilterProvider>
							<Filter selected='All' options={Notification_Filters} />
						</FilterProvider>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Multiple Selection Component</div>
					<div className='component-body '>
						<Settings
							onSelectionClick={() => {}}
							onHeaderClick={() => {}}
							settingSelections={settingSelections}
							headerSelections={selections}
							selectedPage={<div>Selected content displays here</div>}
							selectedPageValue={'details'}
							includeSelection={false}
						/>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Card Scroller</div>
					<div className='component-body '>
						<ShareCardContainer
							//objectCommitment={objectCommitment}
							//fileCommitment={fileCommitment}
							stats={{}}
							shares={[
								{
									storage_id: 1,
									currentSizeMB: 10,
									currentSizeGB: 12,
									currentSizeTB: 45,
									currentSizePB: 0,
									status: 'active',
									publicAccess: true,
									primary_location: 'BHM',
									name: 'Test name share',
								},
							]}
							viewShare={() => {}}
							changeToManageStorage={() => {}}
							goToShareDetail={() => {}}
							loading={false}
						/>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Accordian Item</div>
					<div className='component-body '>
						{invoices &&
							invoices.map((record, index) => (
								<AccordianItem
									id={index}
									key={record.invoice_number}
									headers={INVOICE_SUMMARY_HEADERS}
									detailHeaders={INVOICE_DETAIL_HEADERS}
									data={record}
									onClick={() => {}}
									customOnClick={() => {}}
									classes={index === 0 ? 'alert' : ''}
									expanded={false}
									disableDropDown={false}
									cypressId={`invoice-${record.invoice_number}`}
								/>
							))}
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Ticket</div>
					<div className='component-body '>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'support',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'storage',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'remote hands',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'guest access',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'billing',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'outage',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
						<NewTicket
							id={`ticket-example}`}
							ticket={{
								id: 1234,
								type: 'shipping',
								status: 'active',
								description: 'Example ticket description',
								startDate: '01/01/2022',
							}}
							active={false}
							clickHandler={() => {}}
							selector={0}
						/>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>List Display</div>
					<div className='component-body '>
						<FilterProvider>
							<SortProvider>
								<Notifications
									headers={getHeaders}
									organizationId={345361}
									portalLogs={[
										{
											username: 'example text',
											type: 'description',
											city: 'city',
											displayDate: '02-02-22',
											displayTime: '4:00pm',
										},
										{
											username: 'example text',
											type: 'description',
											city: 'city',
											displayDate: '02-02-22',
											displayTime: '4:00pm',
										},
									]}
									badgeLogs={[]}
								/>
							</SortProvider>
						</FilterProvider>
					</div>
				</div>
				<div className='component'>
					<Divider />
					<div className='component-title heading70'>Header Display</div>
					<div className='component-body '>
						<UserDetails
							image={profileImage}
							user={null}
							fields={{
								type: 'horizontal',
								top: [
									{ label: 'Email', value: 'exampleemail@dcblox.com' },
									{ label: 'label', value: '' },
								],
								bottom: [
									{ label: 'Role', value: 'Owner' },
									{ label: 'Last Login', value: '02/02/2022' },
								],
							}}
							selectedToggle='portal'
						/>
					</div>
				</div>
			</div>
		</ComponentListStyle>
	);
};
